import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showConsentModal: false,
};

const userConsentSlice = createSlice({
  name: 'userConsent',
  initialState,
  reducers: {
    showConsentModal: (state, action) => {
      state.showConsentModal = action.payload;
    },
  },
});

export const { showConsentModal } = userConsentSlice.actions;

export const userConsentSliceReducer = userConsentSlice.reducer;
